import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      <div className="terms-of-service__container">
        <h1 className="terms-of-service__title">Terms of Service</h1>
        <p className="terms-of-service__last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        
        <section className="terms-of-service__section">
          <h2 className="terms-of-service__subtitle">1. Acceptance of Terms</h2>
          <p>By accessing and using ChoiceRealms, you accept and agree to be bound by the terms and provision of this agreement.</p>
        </section>

        <section className="terms-of-service__section">
          <h2 className="terms-of-service__subtitle">2. Account Registration</h2>
          <p>To use certain features of ChoiceRealms, you must register for an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.</p>
        </section>

        <section className="terms-of-service__section">
          <h2 className="terms-of-service__subtitle">3. User Conduct</h2>
          <p>You agree not to use ChoiceRealms for any unlawful purpose or any purpose prohibited under this clause. You agree not to use ChoiceRealms in any way that could damage the website, services, or general business of ChoiceRealms.</p>
        </section>

        <section className="terms-of-service__section">
          <h2 className="terms-of-service__subtitle">4. Intellectual Property</h2>
          <p>The content on ChoiceRealms, including without limitation, the text, software, scripts, graphics, photos, sounds, music, videos, interactive features, and the like and the trademarks, service marks, and logos contained therein, are owned by or licensed to ChoiceRealms.</p>
        </section>

        <section className="terms-of-service__section">
          <h2 className="terms-of-service__subtitle">5. User-Generated Content</h2>
          <p>You retain any and all of your rights to any content you submit, post, or display on or through ChoiceRealms and you are responsible for protecting those rights. We take no responsibility and assume no liability for content you or any third party posts on or through ChoiceRealms.</p>
        </section>

        <section className="terms-of-service__section">
          <h2 className="terms-of-service__subtitle">6. Termination</h2>
          <p>We may terminate or suspend your account and bar access to ChoiceRealms immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.</p>
        </section>

        <section className="terms-of-service__section">
          <h2 className="terms-of-service__subtitle">7. Limitation of Liability</h2>
          <p>In no event shall ChoiceRealms, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use ChoiceRealms.</p>
        </section>

        <section className="terms-of-service__section">
          <h2 className="terms-of-service__subtitle">8. Governing Law</h2>
          <p>These Terms shall be governed and construed in accordance with the laws of [Your Country/State], without regard to its conflict of law provisions.</p>
        </section>

        <section className="terms-of-service__section">
          <h2 className="terms-of-service__subtitle">9. Changes to Terms</h2>
          <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. What constitutes a material change will be determined at our sole discretion.</p>
        </section>

        <section className="terms-of-service__section">
          <h2 className="terms-of-service__subtitle">10. Contact Us</h2>
          <p>If you have any questions about these Terms, please contact us at:</p>
          <p>ChoiceRealms<br />123 RPG Street<br />Game City, GC 12345<br />United States<br />Email: terms@choicerealms.com</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
